/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Senddrafts_Autosave_Error3Inputs */

const en_coinvestments_senddrafts_autosave_error3 = /** @type {(inputs: Coinvestments_Senddrafts_Autosave_Error3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Couldn't save — changes reverted`)
};

/**
* | output |
* | --- |
* | "Couldn't save — changes reverted" |
*
* @param {Coinvestments_Senddrafts_Autosave_Error3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_senddrafts_autosave_error3 = /** @type {((inputs?: Coinvestments_Senddrafts_Autosave_Error3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Senddrafts_Autosave_Error3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_senddrafts_autosave_error3(inputs)
});
export { coinvestments_senddrafts_autosave_error3 as "coInvestments_sendDrafts_autoSave_error" }